import { render, staticRenderFns } from "./medicalOrderDetail.vue?vue&type=template&id=7235f5f4&scoped=true&"
import script from "./medicalOrderDetail.vue?vue&type=script&lang=js&"
export * from "./medicalOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./medicalOrderDetail.vue?vue&type=style&index=0&id=7235f5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7235f5f4",
  null
  
)

export default component.exports